export const IPA_GLOBE_DEFAULTS = {
  povLat: 48.2082,
  povLng: 16.3738,
  povAltitude: 1000,
  povTransitionMs: 1000,
  hubLat: 48.2082,
  hubLng: 16.3738,
  hubPointColor: "#ff0000",
  destinationPointColor: "#ffffff",
  hubRadius: 0.5,
  pointRadius: 0.3,
  globeColor: "#4B0000",
  globeEmissive: "#180000",
  globeEmissiveIntensity: 0.1,
  globeOpacity: 0.7,
  atmosphereColor: "#ffffff",
  atmosphereAltitude: 0.1,
  showAtmosphere: true,
  hexPolygonColor: "rgba(255,255,255,0.7)",
  arcColor: "#ffffff",
  arcStroke: 0.2,
  arcDashAnimateTime: 3000,
};
